import Syncable from '@/syncing/Syncable.js'
import backendHandler from '@/BackendAPI.js'
import { useCanvasStore } from '@/store/canvas.js'
import _ from 'lodash'
import { isBarnPrecondition, isInstanceNotStalePrecondition, isLoggedInPrecondition, isOnlinePrecondition } from '@/syncing/SyncablePreconditions.js'

class BaseCanvasSyncable extends Syncable {
  constructor(globalUniqueIdentifier) {
    super(globalUniqueIdentifier, 1000 * 60 * 10, [isBarnPrecondition, isOnlinePrecondition, isLoggedInPrecondition, isInstanceNotStalePrecondition])
  }

  hasInitialData() {
    return !!useCanvasStore().getBaseCanvas(this.globalUniqueIdentifier)
  }

  async workload() {
    const baseCanvasResponse = await backendHandler.get(this.globalUniqueIdentifier, {
      path: '/api/cameraCanvases',
      priority: 2,
    })
    if (!baseCanvasResponse.ok) return
    const currentBaseCanvas = useCanvasStore().getBaseCanvas(this.globalUniqueIdentifier)
    if (currentBaseCanvas && _.isEqual(currentBaseCanvas, baseCanvasResponse.data)) return
    useCanvasStore().baseCanvases[this.globalUniqueIdentifier] = baseCanvasResponse.data
  }

  static getSyncableHandle() {
    return 'base-canvas'
  }
}

export default BaseCanvasSyncable
